import Vue from 'vue';

export default {

    SET_SEARCHTERM (state, searchTerm) {
        state.searchTerm = searchTerm;
    },

    SET_NOW_UTC (state, nowUtc) {
        state.nowUtc = nowUtc;
    },
    BROWSER_RESIZED (state, ww){
        state.ww = ww;
    },
    SET_ENTITIES_FOR_FILTER(state, entities){
        state.entitiesFilter = entities;
    },
    SET_UNIVERSES_FOR_FILTER(state, universes){
        state.universesFilter = universes;
    },
    SET_EVENTS_FOR_FILTER(state, events){
        state.eventsFilter = events;
    },
    SET_TAKERS_FOR_FILTER(state, takers){
        state.takersFilter = takers;
    },
    CLEAR_ALL_FILTERS(state){
        state.entitiesFilter = [];
        state.universesFilter = [];
        state.eventsFilter = [];
        state.takersFilter = [];
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js